/**
 * Detects Google Chrome (desktop) for screen-recording tests.
 * Excludes Safari, Edge, Opera, Brave, Samsung Internet, Vivaldi, and Chrome iOS.
 */
export function isGoogleChrome() {
	const ua = navigator.userAgent.toLowerCase();
	const isChromium =
		/chrome/.test(ua) &&
		!/edg/.test(ua) &&
		!/opr/.test(ua) &&
		!/brave/.test(ua) &&
		!/samsungbrowser/.test(ua) &&
		!/vivaldi/.test(ua) &&
		!/crios/.test(ua) &&
		!/fxios/.test(ua);
	const isSafari = /safari/.test(ua) && !/chrome/.test(ua);
	return isChromium && !isSafari;
}

export function isMobileOrTabletDevice() {
	const ua = navigator.userAgent.toLowerCase();
	return /android|iphone|ipad|ipod|mobile|tablet/.test(ua);
}

export function testRequiresChromeDesktop(test) {
	return test && Number(test.is_screen_recording_enabled) === 1;
}

export function isUnsupportedBrowserForScreenRecording(test) {
	if (!testRequiresChromeDesktop(test)) {
		return false;
	}
	return !isGoogleChrome() || isMobileOrTabletDevice();
}
